export const ORG_OMIT_KEYS = [
  "tax_settings",
  "is_active",
  "internal_number",
  "gstinList",
  "credit_limit",
  "credit_cycle",
  "advance_limit",
  "associated_user",
  "_id",
];

export const VALID_BUSINESS_CODES = ["SP", "OPC", "PF", "LLP", "HUF"];
